export default "__VITE_PUBLIC_ASSET__a3815d2a__"